var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Section',{attrs:{"width":"sm"}},[_c('div',{staticClass:"rich-text",domProps:{"innerHTML":_vm._s(_vm.$prismic.asHtml(_vm.slice.primary.content1))}})])
}
var staticRenderFns = []

export { render, staticRenderFns }